import {Injectable} from "@angular/core";
import {AngularFirestore} from "@angular/fire/firestore";
import {AngularFireStorage} from "@angular/fire/storage";
import {AuthService} from "./auth.service";
import {Observable} from "rxjs";
import {Court} from "../models/court";
import {map} from "rxjs/operators";
import {User} from "../models/user.model";
import { GeneralInfo } from "../models/info.model";

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private authService: AuthService
  ) {
  }

  getUsers(page?: number, limit?: number): Observable<User[]> {
    return this.afs.collection<User>('users').get()
      .pipe(
        map(data => {
          return data.docs.map(doc => {
            const user = doc.data() as User;
            return user;
          });
        })
      );
  }

  getUsersBySecondName(query: string): Observable<User[]> {
    return this.afs.collection<User>('users', (ref) => {
      return ref.where('secondName', '>=', query).where('secondName', '<=', query + '\uf8ff')
    }).get()
      .pipe(
        map(data => {
          return data.docs.map(doc => {
            const user = doc.data() as User;
            return user;
          });
        })
      );
  }

  getGeneralInfo(): Observable<GeneralInfo> {
    return this.afs.doc<GeneralInfo>('info/generalInfo').get()
    .pipe(
      map(data => {
        return data.data() as GeneralInfo;
      })
    );
  }
}
